// extracted by mini-css-extract-plugin
export var linkText = "_r0-0";